import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { createContext, useState } from "react";
import { Page } from "./components/Page/Page";
import { ThemeProvider, createTheme } from '@mui/material/styles';

export const GlobalContext = createContext(null);

function App() {
  const [isOverlayVisible, setIsOverlayVisible] = useState(true);
  const [center, setCenter] = useState(null);
  const [zoom, setZoom] = useState(null);
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [allClinics, setAllClinics] = useState(null);
  const [skinProblems, setSkinProblems] = useState([]);
  const [visibleClinicCardIDs, setVisibleClinicCardIDs] = useState(null);
  const [userGPSCoordinates, setUserGPSCoordinates] = useState(null);
  const [
    selectedFilterSkinConditions,
    setSelectedFilterSkinConditions,
  ] = useState([]);
  const [searchValueCoordinates, setSearchValueCoordinates] = useState(null);

  const [footerHeight, setFooterHeight] = useState(73);

  const client = Client({
    url:
      process.env.NODE_ENV === "production"
        ? window.location.origin + "/graphql"
        : "https://knowyourskin.britishskinfoundation.test/graphql",
    exchanges: [cacheExchange, fetchExchange],
  });

  const theme = createTheme({});

  return (
    <Provider value={client}>
      <ThemeProvider theme={theme}>
      <GlobalContext.Provider
        value={{
          center,
          setCenter,
          zoom,
          setZoom,
          value,
          setValue,
          inputValue,
          setInputValue,
          options,
          setOptions,
          allClinics,
          setAllClinics,
          skinProblems,
          setSkinProblems,
          visibleClinicCardIDs,
          setVisibleClinicCardIDs,
          userGPSCoordinates,
          setUserGPSCoordinates,
          selectedFilterSkinConditions,
          setSelectedFilterSkinConditions,
          searchValueCoordinates,
          setSearchValueCoordinates,
          footerHeight,
          setFooterHeight,
          isOverlayVisible,
          setIsOverlayVisible,
        }}
      >
        <style
          dangerouslySetInnerHTML={{
            __html: `
            body {
              margin: 0;
            }
          `,
          }}
        />
        <Page />
      </GlobalContext.Provider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
